import { useTheme } from 'styled-components';

export function NotFoundRoute() {
	const theme = useTheme();
	return (
		<div className="bg-overlay-dark">
			<div className="mx-auto form-container d-flex flex-column align-items-center py-3">
				<div className="m-4 mt-5 text-center">
					<p
						style={{
							color: theme.TA_GREEN,
							fontSize: '2.625rem',
							fontWeight: 400,
							margin: '150px 0'
						}}
					>
						Opps! Nothing here.
					</p>
				</div>
				{/* <div className="p-4 mt-0 my-md-5 ta-form-container d-flex justify-content-center"></div> */}
			</div>
		</div>
	);
}
